// Zusätzliche, typabhängige Felder für die Event-Erfassung
// Jede Definition: { key, label, type, placeholder }
export const EVENT_TYPE_SCHEMAS = {
  'Turnier': [
    { key: 'game', label: 'Spiel', type: 'text', placeholder: 'z.B. CS2, LoL, Valorant' },
    { key: 'platform', label: 'Plattform', type: 'text', placeholder: 'PC, Konsole, Mixed' },
    { key: 'rulesUrl', label: 'Regelwerk (URL)', type: 'url', placeholder: 'https://…' },
    { key: 'prizePool', label: 'Preisgeld/Preise', type: 'text', placeholder: 'z.B. 500€ + Goodies' },
  ],
  'Training': [
    { key: 'topic', label: 'Thema', type: 'text', placeholder: 'Z.B. Aim-Training, Macro' },
    { key: 'coach', label: 'Coach', type: 'text', placeholder: 'Name des Trainers' },
    { key: 'level', label: 'Level', type: 'text', placeholder: 'Einsteiger, Fortgeschrittene…' },
  ],
  'Community-Event': [
    { key: 'host', label: 'Host/Moderator', type: 'text', placeholder: 'Veranstalter/Host' },
    { key: 'audience', label: 'Zielgruppe', type: 'text', placeholder: 'Alle, Ü18, Team-Mitglieder…' },
  ],
  'Livestream': [
    { key: 'platform', label: 'Plattform', type: 'text', placeholder: 'Twitch, YouTube…' },
    { key: 'streamUrl', label: 'Stream-Link', type: 'url', placeholder: 'https://…' },
    { key: 'coHosts', label: 'Co-Hosts/Gäste', type: 'text', placeholder: 'Kommagetrennt' },
  ],
  'Workshop': [
    { key: 'speaker', label: 'Dozent:in', type: 'text', placeholder: 'Name' },
    { key: 'materialsUrl', label: 'Unterlagen (URL)', type: 'url', placeholder: 'https://…' },
  ],
  'Vortrag': [
    { key: 'speaker', label: 'Speaker', type: 'text', placeholder: 'Name' },
    { key: 'slidesUrl', label: 'Folien (URL)', type: 'url', placeholder: 'https://…' },
  ],
  'Meetup': [
    { key: 'room', label: 'Raum/Location-Detail', type: 'text', placeholder: 'z.B. Raum B-201' },
    { key: 'contact', label: 'Kontakt vor Ort', type: 'text', placeholder: 'Name/Telefon' },
  ],
  'LAN-Party': [
    { key: 'bring', label: 'Mitbringen', type: 'text', placeholder: 'z.B. Mehrfachsteckdose, Netzwerkkabel' },
    { key: 'room', label: 'Raum/Location-Detail', type: 'text', placeholder: 'z.B. Halle 1' },
  ],
  'Release-Event': [
    { key: 'product', label: 'Produkt/Spiel', type: 'text', placeholder: 'Name' },
    { key: 'publisher', label: 'Publisher/Studio', type: 'text', placeholder: 'Name' },
  ],
  'Coaching': [
    { key: 'coach', label: 'Coach', type: 'text', placeholder: 'Name' },
    { key: 'topic', label: 'Schwerpunkt', type: 'text', placeholder: 'Z.B. Strategie, Rollen' },
  ],
  'Bootcamp': [
    { key: 'coach', label: 'Coach/Staff', type: 'text', placeholder: 'Name' },
    { key: 'focus', label: 'Fokus', type: 'text', placeholder: 'Z.B. Teamplay, Kondition' },
  ],
  'Q&A': [
    { key: 'host', label: 'Host', type: 'text', placeholder: 'Name' },
    { key: 'topic', label: 'Thema', type: 'text', placeholder: 'Kurzbeschreibung' },
  ],
  'Charity': [
    { key: 'beneficiary', label: 'Zweck/Organisation', type: 'text', placeholder: 'Name/Projekt' },
    { key: 'donationUrl', label: 'Spendenlink', type: 'url', placeholder: 'https://…' },
  ],
  'Wettbewerb': [
    { key: 'discipline', label: 'Disziplin', type: 'text', placeholder: 'z.B. Zeitfahren, 1v1' },
    { key: 'prizes', label: 'Preise', type: 'text', placeholder: 'Kurzbeschreibung' },
  ],
  'Testspiel': [
    { key: 'opponent', label: 'Gegner/Team', type: 'text', placeholder: 'Name' },
    { key: 'format', label: 'Format', type: 'text', placeholder: 'Bo1, Bo3…' },
  ],
  'Scrim': [
    { key: 'opponent', label: 'Gegner/Team', type: 'text', placeholder: 'Name' },
    { key: 'format', label: 'Format', type: 'text', placeholder: 'Bo1, Bo3…' },
  ],
  'Viewing Party': [
    { key: 'event', label: 'Event/Match', type: 'text', placeholder: 'Name des Events/Matches' },
    { key: 'streamUrl', label: 'Stream-Link', type: 'url', placeholder: 'https://…' },
  ],
  'Hackathon': [
    { key: 'theme', label: 'Thema', type: 'text', placeholder: 'Schwerpunkt' },
    { key: 'repoUrl', label: 'Repo/Info (URL)', type: 'url', placeholder: 'https://…' },
  ],
};
